export const states_dictionary = { 
  "estado": "State", 
  "locales": "Storefront", 
  "orientación": "Orientation",
  "vistas": "Views",
  "terrenos": "Land",
  "catacterísticas": "Characteristics",
  "calefacción": "Heating",
  "edificio": "Building",
  "urbanización": "Gated community",
  "seguridad": "Security",
  "garaje": "Parking"
};

export const tags_dictionary = [
  {
    key: "reformado",
    tag: "reformado", 
    tagEN: "rebuilt",
    categories: ["estado"],
    url: "person/icons/visible_593374_cvsdfn.png"
  },
  {
    key: "a reformar",
    tag: "para reformar",
    tagEN: "to renovate",
    categories: ["estado"],
    url: "person/icons/visible_593374_cvsdfn.png"
  },
  {
    key: "a estrenar",
    tag: "a estrenar",
    tagEN: "new",
    categories: ["estado"],
    url: "person/icons/visible_593374_cvsdfn.png"
  },
  {
    key: "obra nueva",
    tag: "obra nueva",
    tagEN: "new construction",
    categories: ["estado"],
    url: "person/icons/visible_593374_cvsdfn.png"
  },
  {
    key: "traspaso",
    tag: "traspaso",
    tagEN: "transfer",
    categories: ["locales"],
    url: "person/icons/help_12055988_xvpydi.png"
  },
  {
    key: "orientación este",
    tag: "orientación este",
    tagEN: "east facing",
    categories: ["orientación"],
    url: "person/icons/explore_7988857_etldck.png"
  },
  {
    key: "orientación sur",
    tag: "orientación sur",
    tagEN: "south facing",
    categories: ["orientación"],
    url: "person/icons/explore_7988857_etldck.png"
  },
  {
    key: "orientación norte",
    tag: "orientación norte",
    tagEN: "north facing",
    categories: ["orientación"],
    url: "person/icons/explore_7988857_etldck.png"
  },
  {
    key: "orientación oeste",
    tag: "orientación oeste",
    tagEN: "west facing",
    categories: ["orientación"],
    url: "person/icons/explore_7988857_etldck.png"
  },
  {
    key: "vistas despejadas",
    tag: "vistas despejadas",
    tagEN: "open views",
    categories: ["vistas"],
    url: "person/icons/visible_593374_cvsdfn.png"
  },
  {
    key: "vistas al mar",
    tag: "vistas al mar",
    tagEN: "sea views",
    categories: ["vistas"],
    url: "person/icons/visible_593374_cvsdfn.png"
  },
  {
    key: "vistas al monte",
    tag: "vistas al monte",
    tagEN: "mountain views",
    categories: ["vistas"],
    url: "person/icons/visible_593374_cvsdfn.png"
  },
  {
    key: "hostelería",
    tag: "hostelería",
    tagEN: "hospitality",
    categories: ["locales"],
    url: "person/icons/bell_2046909_uzguqs.png"
  },
  {
    key: "edificable",
    tag: "edificable",
    tagEN: "buildable",
    categories: ["terrenos"],
    url: "person/icons/appartment_4170001_udp2cj.png"
  },
  {
    key: "urbanizable",
    tag: "urbanizable",
    tagEN: "developable",
    categories: ["terrenos"],
    url: "person/icons/appartment_4170001_udp2cj.png"
  },
  {
    key: "interior",
    tag: "interior",
    tagEN: "interior",
    categories: ["catacterísticas"],
    url: "person/icons/window_544081_opedyp.png"
  },
  {
    key: "exterior",
    tag: "exterior",
    tagEN: "exterior",
    categories: ["catacterísticas"],
    url: "person/icons/window_544081_opedyp.png"
  },
  {
    key: "amueblado",
    tag: "amueblado",
    tagEN: "furnished",
    categories: ["catacterísticas"],
    url: "person/icons/cabinet_2944414_ghcf43.png"
  },
  {
    key: "no amueblado",
    tag: "no amueblado",
    tagEN: "not furnished",
    categories: ["catacterísticas"],
    url: "person/icons/cabinet_2944414_ghcf43.png"
  },
  {
    key: "loft",
    tag: "loft",
    tagEN: "loft",
    categories: ["catacterísticas"],
    url: "person/icons/stairs_6245678_xoissl.png"
  },
  {
    key: "condominio",
    tag: "condominio",
    tagEN: "condo",
    categories: ["catacterísticas"],
    url: "person/icons/apartment_9090023_nveqz3.png"
  },
  {
    key: "adosado",
    tag: "adosado",
    tagEN: "semi-detached",
    categories: ["catacterísticas"],
    url: "person/icons/townhouse_4233772_fkkyf4.png"
  },
  {
    key: "pareado",
    tag: "pareado",
    tagEN: "semi-detached",
    categories: ["catacterísticas"],
    url: "person/icons/house_698795_fbvno8.png"
  },
  {
    key: "piscina",
    tag: "piscina",
    tagEN: "pool",
    categories: ["catacterísticas"],
    url: "person/icons/swimming-pool_1599529_ow32mr.png"
  },
  {
    key: "jardín",
    tag: "jardín",
    tagEN: "garden",
    categories: ["catacterísticas"],
    url: "person/icons/leaf_621715_bn8u3k.png"
  },
  {
    key: "barbacoa",
    tag: "barbacoa",
    tagEN: "barbecue",
    categories: ["catacterísticas"],
    url: "person/icons/bbq_7942508_nebgtq.png"
  },
  {
    key: "terraza",
    tag: "terraza",
    tagEN: "terrace",
    categories: ["catacterísticas"],
    url: "person/icons/terrace_8080093_czce4w.png"
  },
  {
    key: "armarios empotrados",
    tag: "armarios empotrados",
    tagEN: "built-in wardrobes",
    categories: ["catacterísticas"],
    url: "person/icons/cupboard_5612967_wkjrzi.png"
  },
  {
    key: "balcón",
    tag: "balcón",
    tagEN: "balcony",
    categories: ["catacterísticas"],
    url: "person/icons/window_3062499_bom9kd.png"
  },
  {
    key: "ventanas climalit",
    tag: "ventanas climalit",
    tagEN: "climalit windows",
    categories: ["catacterísticas"],
    url: "person/icons/window_2387988_haosmg.png"
  },
  {
    key: "solárium",
    tag: "solárium",
    tagEN: "solarium",
    categories: ["catacterísticas"],
    url: "person/icons/sun_3520308_hga6xc.png"
  },
  {
    key: "cine",
    tag: "cine",
    tagEN: "cinema",
    categories: ["catacterísticas"],
    url: "person/icons/camera_1661646_xzvykm.png"
  },
  {
    key: "sauna",
    tag: "sauna",
    tagEN: "sauna",
    categories: ["catacterísticas"],
    url: "person/icons/hot-stones_8613251_x2irih.png"
  },
  {
    key: "detector de humos",
    tag: "detector de humos",
    tagEN: "smoke detector",
    categories: ["catacterísticas"],
    url: "person/icons/smoke_6815995_vscr2p.png"
  },
  {
    key: "almacén",
    tag: "almacén",
    tagEN: "warehouse",
    categories: ["catacterísticas"],
    url: "person/icons/warehouse_8646384_s9xisu.png"
  },
  {
    key: "antena tv",
    tag: "antena tv",
    tagEN: "tv antenna",
    categories: ["catacterísticas"],
    url: "person/icons/television_1082765_e9eogd.png"
  },
  {
    key: "cama individual",
    tag: "cama individual",
    tagEN: "single bed",
    categories: ["catacterísticas"],
    url: "person/icons/bed_3009931_rmo3t2.png"
  },
  {
    key: "cama doble",
    tag: "cama doble",
    tagEN: "double bed",
    categories: ["catacterísticas"],
    url: "person/icons/bed_3009931_rmo3t2.png"
  },
  {
    key: "dos camas",
    tag: "dos camas",
    tagEN: "two beds",
    categories: ["catacterísticas"],
    url: "person/icons/bed_3009931_rmo3t2.png"
  },
  {
    key: "cocina amueblada",
    tag: "cocina amueblada",
    tagEN: "furnished kitchen",
    categories: ["catacterísticas"],
    url: "person/icons/kitchen_8857974_m9xlme.png"
  },
  {
    key: "cocina equipada",
    tag: "cocina equipada",
    tagEN: "equipped kitchen",
    categories: ["catacterísticas"],
    url: "person/icons/kitchen_7842210_zmdaka.png"
  },
  {
    key: "lavavajillas",
    tag: "lavavajillas",
    tagEN: "dishwasher",
    categories: ["catacterísticas"],
    url: "person/icons/dishwasher_7842186_lyrlvo.png"
  },
  {
    key: "cocina americana",
    tag: "cocina americana",
    tagEN: "american kitchen",
    categories: ["catacterísticas"],
    url: "person/icons/kitchen_8857974_m9xlme.png"
  },
  {
    key: "gas natural",
    tag: "gas natural",
    tagEN: "natural gas",
    categories: ["catacterísticas"],
    url: "person/icons/gas-cylinder_8357145_q0n4o0.png"
  },
  {
    key: "extractor de humos",
    tag: "extractor de humos",
    tagEN: "smoke extractor",
    categories: ["catacterísticas"],
    url: "person/icons/smoke_6815995_vscr2p.png"
  },
  {
    key: "suelo parquet",
    tag: "suelo parquet",
    tagEN: "parquet floor",
    categories: ["catacterísticas"],
    url: "person/icons/layer_900158_okcavs.png"
  },
  {
    key: "suelo gres",
    tag: "suelo gres",
    tagEN: "ceramic floor",
    categories: ["catacterísticas"],
    url: "person/icons/layer_900158_okcavs.png"
  },
  {
    key: "suelo mármol",
    tag: "suelo mármol",
    tagEN: "marble floor",
    categories: ["catacterísticas"],
    url: "person/icons/layer_900158_okcavs.png"
  },
  {
    key: "suelo terrazo",
    tag: "suelo terrazo",
    tagEN: "terrazzo floor",
    categories: ["catacterísticas"],
    url: "person/icons/layer_900158_okcavs.png"
  },
  {
    key: "suelo tarima",
    tag: "suelo tarima",
    tagEN: "platform floor",
    categories: ["catacterísticas"],
    url: "person/icons/layer_900158_okcavs.png"
  },
  {
    key: "suelo técnico",
    tag: "suelo técnico",
    tagEN: "technical floor",
    categories: ["catacterísticas"],
    url: "person/icons/layer_900158_okcavs.png"
  },
  {
    key: "aire acondicionado",
    tag: "aire acondicionado",
    tagEN: "air conditioning",
    categories: ["catacterísticas"],
    url: "person/icons/snow_3293527_a5dytz.png"
  },
  {
    key: "calefacción individual: bomba de frío/calor",
    tag: "Bomba frío/calor",
    tagEN: "heat/cold pump",
    categories: ["catacterísticas"],
    url: "person/icons/hot-surface_5642932_aif9kp.png"
  },
  {
    key: "calefacción central",
    tag: "calefacción central",
    tagEN: "central heating",
    categories: ["catacterísticas"],
    url: "person/icons/hot-surface_5642932_aif9kp.png"
  },
  {
    key: "calefacción eléctrica",
    tag: "calefacción eléctrica",
    tagEN: "electric heating",
    categories: ["catacterísticas"],
    url: "person/icons/lightning_10522405_kyos3o.png"
  },
  {
    key: "calefacción individual",
    tag: "calefacción individual",
    tagEN: "individual heating",
    categories: ["catacterísticas"],
    url: "person/icons/hot-surface_5642932_aif9kp.png"
  },
  {
    key: "calefacción gas natural individual",
    tag: "Gas individual",
    tagEN: "individual gas",
    categories: ["calefacción"],
    url: "person/icons/hot-surface_5642932_aif9kp.png"
  },
  {
    key: "calefacción gas natural central",
    tag: "Gas central",
    tagEN: "central gas",
    categories: ["calefacción"],
    url: "person/icons/hot-surface_5642932_aif9kp.png"
  },
  {
    key: "calefacción gasoil",
    tag: "calefacción gasoil",
    tagEN: "gasoil heating",
    categories: ["catacterísticas"],
    url: "person/icons/hot-surface_5642932_aif9kp.png"
  },
  {
    key: "calefacción individual: gas propano/butano",
    tag: "calefacción gas propano/butano",
    tagEN: "gas heating",
    categories: ["catacterísticas"],
    url: "person/icons/hot-surface_5642932_aif9kp.png"
  },
  {
    key: "suelo radiante",
    tag: "suelo radiante",
    tagEN: "radiant floor",
    categories: ["catacterísticas"],
    url: "person/icons/hot-surface_5642932_aif9kp.png"
  },
  {
    key: "gas butano",
    tag: "gas butano",
    tagEN: "butane gas",
    categories: ["catacterísticas"],
    url: "person/icons/gas-cylinder_8357145_q0n4o0.png"
  },
  {
    key: "chimenea",
    tag: "chimenea",
    tagEN: "chimney",
    categories: ["catacterísticas"],
    url: "person/icons/fireplace_5616025_s0fwjn.png"
  },
  {
    key: "trastero",
    tag: "trastero",
    tagEN: "warehouse",
    categories: ["catacterísticas"],
    url: "person/icons/warehouse_8646384_s9xisu.png"
  },
  {
    key: "trastero incluido",
    tag: "trastero incluido",
    tagEN: "warehouse included",
    categories: ["catacterísticas"],
    url: "person/icons/warehouse_8646384_s9xisu.png"
  },
  {
    key: "escaleras",
    tag: "escaleras",
    tagEN: "stairs",
    categories: ["edificio"],
    url: "person/icons/stairs_2669425_g2zgkh.png"
  },
  {
    key: "vigilancia 24h",
    tag: "vigilancia 24h",
    tagEN: "24h security",
    categories: ["edificio", "urbanización"],
    url: "person/icons/cctv_2542743_sijg99.png"
  },
  {
    key: "videoportero",
    tag: "videoportero",
    tagEN: "video intercom",
    categories: ["edificio"],
    url: "person/icons/smartphone_3043880_eab3px.png"
  },
  {
    key: "conserje",
    tag: "conserje",
    tagEN: "janitor",
    categories: ["edificio"],
    url: "person/icons/janitor_6025272_er7nv7.png"
  },
  {
    key: "ascensor",
    tag: "ascensor",
    tagEN: "elevator",
    categories: ["edificio"],
    url: "person/icons/elevator_5811560_qoze1e.png"
  },
  {
    key: "acceso personas con movilidad reducida",
    tag: "acceso discapacidad",
    tagEN: "disabled access",
    categories: ["edificio"],
    url: "person/icons/disabled_5274116_dxcfpb.png"
  },
  {
    key: "salida de emergencia",
    tag: "salida de emergencia",
    tagEN: "emergency exit",
    categories: ["edificio"],
    url: "person/icons/exit_2183475_d8nk0b.png"
  },
  {
    key: "portero",
    tag: "portero",
    tagEN: "porter",
    categories: ["edificio"],
    url: "person/icons/smartphone_3043880_eab3px.png"
  },
  {
    key: "piscina comunitaria",
    tag: "piscina comunitaria",
    tagEN: "community pool",
    categories: ["edificio", "urbanización"],
    url: "person/icons/swimming-pool_1599529_ow32mr.png"
  },
  {
    key: "jardín comunitario",
    tag: "jardín comunitario",
    tagEN: "community garden",
    categories: ["edificio", "urbanización"],
    url: "person/icons/leaf_621715_bn8u3k.png"
  },
  {
    key: "zona infantil",
    tag: "zona infantil",
    tagEN: "children's area",
    categories: ["edificio", "urbanización"],
    url: "person/icons/slide_5895597_nvquan.png"
  },
  {
    key: "gimnasio",
    tag: "gimnasio",
    tagEN: "gym",
    categories: ["edificio"],
    url: "person/icons/fitness_2600468_nbn3uq.png"
  },
  {
    key: "pista de tenis",
    tag: "pista de tenis",
    tagEN: "tennis court",
    categories: ["edificio"],
    url: "person/icons/tennis_7942450_enzs3j.png"
  },
  {
    key: "pista de pádel",
    tag: "pista de pádel",
    tagEN: "padel court",
    categories: ["edificio"],
    url: "person/icons/tennis_7942450_enzs3j.png"
  },
  {
    key: "zona verde",
    tag: "zona verde",
    tagEN: "green area",
    categories: ["edificio", "características"],
    url: "person/icons/tree_4319716_llupsp.png"
  },
  {
    key: "urbanizacion privada",
    tag: "urbanizacion privada",
    tagEN: "gated community",
    categories: ["urbanización"],
    url: "person/icons/shield_679709_ph2h5v.png"
  },
  {
    key: "puerta blindada",
    tag: "puerta blindada",
    tagEN: "reinforced door",
    categories: ["seguridad"],
    url: "person/icons/padlock_595413_i2ihw0.png"
  },
  {
    key: "cámara de seguridad",
    tag: "cámara de seguridad",
    tagEN: "security camera",
    categories: ["seguridad"],
    url: "person/icons/cctv_2542743_sijg99.png"
  },
  {
    key: "alarma",
    tag: "alarma",
    tagEN: "alarm",
    categories: ["seguridad"],
    url: "person/icons/alarm_1333461_kcx0oc.png"
  },
  {
    key: "puerta de seguridad",
    tag: "puerta de seguridad",
    tagEN: "security door",
    categories: ["seguridad"],
    url: "person/icons/padlock_595413_i2ihw0.png"
  },
  {
    key: "plaza garaje incluida",
    tag: "garaje",
    tagEN: "garage included",
    categories: ["garaje"],
    url: "person/icons/garage_544093_ssyhr8.png"
  },
  {
    key: "edificio con garaje",
    tag: "garaje",
    tagEN: "garage",
    categories: ["garaje"],
    url: "person/icons/garage_544093_ssyhr8.png"
  },
  {
    key: "plaza para coche grande",
    tag: "garaje",
    tagEN: "large car garage",
    categories: ["garaje"],
    url: "person/icons/garage_544093_ssyhr8.png"
  },
  {
    key: "plaza para coche y moto",
    tag: "garaje",
    tagEN: "car and motorcycle garage",
    categories: ["garaje"],
    url: "person/icons/garage_544093_ssyhr8.png"
  },
  {
    key: "plaza para moto",
    tag: "garaje",
    tagEN: "motorcycle garage",
    categories: ["garaje"],
    url: "person/icons/garage_544093_ssyhr8.png"
  },
  {
    key: "plaza para coche pequeño",
    tag: "garaje",
    tagEN: "small car garage",
    categories: ["garaje"],
    url: "person/icons/garage_544093_ssyhr8.png"
  },
  {
    key: "parking",
    tag: "parking",
    tagEN: "parking",
    categories: ["garaje"],
    url: "person/icons/garage_544093_ssyhr8.png"
  },
  {
    key: "vado permanente",
    tag: "garaje",
    tagEN: "permanent parking",
    categories: ["garaje"],
    url: "person/icons/garage_544093_ssyhr8.png"
  }
]

